<template>
  <div class="mt-4 rounded-lg bg-white sm:p-8 border border-[#e2e8f0]" id="calender">
    <div class="w-full h-12 text-[var(--color-orange)] flex justify-between items-center py-0 px-8
    text-center text-2xl">
      <font-awesome-icon icon="fa-angle-left"
                         id="btn_prev"
                         class="cursor-pointer"
                         :class="{'text-[var(--color-disabled)]': editable === false}"
                         @click.prevent="subMonthToDate"/>
      <div class="date">
        <h4 id="txt_month"
        :class="{'text-[var(--color-disabled)]': editable === false}">
          {{ $t('KssCalendarComponent.months.' + dateObject.getMonth()) }}
        </h4>
      </div>
      <font-awesome-icon icon="fa-angle-right"
                         id="btn_next"
                         class="cursor-pointer"
                         :class="{'text-[var(--color-disabled)]': editable === false}"
                         @click.prevent="addMonthToDate"/>
    </div>
    <div class="weekdays">
      <div id="txt_sunday">{{ $t('KssCalendarComponent.weekdaysShort.sunday') }}</div>
      <div id="txt_monday">{{ $t('KssCalendarComponent.weekdaysShort.monday') }}</div>
      <div id="txt_tuesday">{{ $t('KssCalendarComponent.weekdaysShort.tuesday') }}</div>
      <div id="txt_wednesday">{{ $t('KssCalendarComponent.weekdaysShort.wednesday') }}</div>
      <div id="txt_thursday">{{ $t('KssCalendarComponent.weekdaysShort.thursday') }}</div>
      <div id="txt_friday">{{ $t('KssCalendarComponent.weekdaysShort.friday') }}</div>
      <div id="txt_saturday">{{ $t('KssCalendarComponent.weekdaysShort.saturday') }}</div>
    </div>
    <div class="days" id="txt_days">
      <div v-for="day in daysInMonthBefore" :key="day" class="opacity-20"> {{ day.getDate() }}</div>
      <div v-for="day in daysInMonth" :key="day" @click.prevent="selectDate(day)"
           :class="{'today day' : isToday(day),
           'day bg-[var(--color-orange)] rounded-lg': isSelected(day),
           'bg-[var(--color-disabled)] border-[var(--color-disabled)]':
            editable === false && isSelected(day)}">
        {{ day.getDate() }}
      </div>
      <div v-for="day in daysInMonthAfter" :key="day" class="opacity-20"> {{ day.getDate() }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    editable: {
      type: Boolean,
    },
    initialDate: {
      type: Date,
      default: null,
    },
  },
  name: 'EditKssCalendarComponent',
  data() {
    return {
      dateObject: new Date(),
      selectedDateData: null,
    };
  },
  computed: {
    selectedDate() {
      return this.selectedDateData;
    },
    daysInMonth() {
      const year = this.dateObject.getFullYear();
      const month = this.dateObject.getMonth();
      const date = new Date(year, month, 1);
      const days = [];
      while (date.getMonth() === month) {
        days.push(new Date(date));
        date.setDate(date.getDate() + 1);
      }
      return days;
    },
    daysInMonthBefore() {
      const date = new Date(this.dateObject);
      date.setDate(1);
      date.setMonth(this.dateObject.getMonth() - 1);
      const month = date.getMonth();
      const days = [];
      while (date.getMonth() === month) {
        days.push(new Date(date));
        date.setDate(date.getDate() + 1);
      }
      const subtractCount = date.getDay() === 0 ? -days.length : date.getDay();
      return days.slice(-subtractCount);
    },
    daysInMonthAfter() {
      const date = new Date(this.dateObject);
      date.setDate(1);
      date.setMonth(this.dateObject.getMonth() + 1);
      const refDate = new Date(date);
      const month = date.getMonth();
      const days = [];
      while (date.getMonth() === month) {
        days.push(new Date(date));
        date.setDate(date.getDate() + 1);
      }
      const takeCount = refDate.getDay() === 0 ? 0 : 7 - refDate.getDay();
      return days.slice(0, takeCount);
    },
  },
  methods: {
    addMonthToDate() {
      this.dateObject.setMonth(this.dateObject.getMonth() + 1);
      this.dateObject = new Date(this.dateObject);
    },
    subMonthToDate() {
      this.dateObject.setMonth(this.dateObject.getMonth() - 1);
      this.dateObject = new Date(this.dateObject);
    },
    selectDate(date) {
      if (this.editable === false) return;
      this.selectedDateData = date;
      this.$emit('updateDate', date);
    },
    isToday(day) {
      const today = new Date();
      return (today.toDateString() === day.toDateString());
    },
    isSelected(day) {
      if (this.selectedDate) {
        return (day.toDateString() === this.selectedDate.toDateString());
      }
      return false;
    },
    syncFromInitialDate() {
      if (!this.initialDate || typeof this.initialDate.getFullYear !== 'function') {
        this.selectedDateData = null;
        return;
      }
      const d = new Date(this.initialDate.getTime());
      this.selectedDateData = d;
      this.dateObject = new Date(d.getFullYear(), d.getMonth(), 1);
    },
  },
  watch: {
    initialDate: {
      deep: true,
      handler() {
        this.syncFromInitialDate();
      },
    },
  },
  mounted() {
    this.syncFromInitialDate();
  },
};
</script>

<style scoped>
.weekdays {
  @apply h-12 w-full py-0 px-2 flex items-center;
}

.weekdays div {
  @apply text-lg font-light w-[calc(100%/7)] flex justify-center items-center
    text-[var(--color-disabled)] tracking-widest;
}

.days {
  @apply w-full flex flex-wrap py-0 px-1 justify-center;
}

.days div {
  @apply text-lg font-medium m-1 h-12 flex items-center justify-center
    transition-colors duration-200 w-[calc((100%-0.3rem*14-0.2rem)/7)];
}

.days div:hover:not(.today) {
  @apply border-2 border-[var(--color-deep-champagne)] rounded-lg cursor-pointer;
}

.today {
  @apply rounded-lg border border-[var(--color-deep-champagne)] border-solid;
}
</style>
